import Vue from 'vue';
import {Vue as _Vue} from "vue/types/vue";
import {VTextField} from "vuetify/lib";

const textField = VTextField as unknown as typeof _Vue;

export default Vue.extend({
	name: 'AsiTextFieldSimple',
	extends: textField,
	props: {
		hideDetails: {
			type: String,
			default: 'auto',
		},
		dense: {
			type: Boolean,
			default: true,
		},
		flat: {
			type: Boolean,
			default: true,
		},
		solo: {
			type: Boolean,
			default: true,
		},
	},
});
